<div class="loading" *ngIf="loader"></div>
<div class="content_top_margin">
    <div (click)="tooltipExpandFalse()">
        <div>
            <div class="text-center">
                <img src="./assets/icons/home-icon.svg" class="img-wifgt" alt="">
            </div>
        </div>
        <div class="top_spa_aft_sect_heading">
            <div class=""><i class="fas fa-arrow-alt-circle-up"></i></div>
            <h2 role="heading" aria-level="1"
                class="text-center  space_between_section sidebar_head_Txt"
                [ngClass]="currentLang==currLangFr?'center-margin-fr':''">
                {{ 'summarypage.headingtitlePrev' | translate }}{{applicantName}}!<br>
                <ng-container *ngIf="preQualObj.flow_type==prequalType">
                    {{ 'summarypage.headingtitle' | translate }}
                </ng-container>
                <ng-container *ngIf="preQualObj.flow_type==switchType">
                    {{ 'summarypage.headingtitleSwitch' | translate }}
                </ng-container>
            </h2>
            <div class="row no-gutters marginCls" >
                <div class="col-12 text-center">
                    <ng-container *ngIf="preQualObj.flow_type==prequalType">
                        <span class="advisorFontStyle">{{
                            'summarypage.discussyourtitle' |
                            translate }}</span>
                    </ng-container>
                    <ng-container *ngIf="preQualObj.flow_type==switchType">
                        <span class="advisorFontStyle">{{
                            'summarypage.discussyourtitleSwitch'
                            | translate }}</span>
                    </ng-container>

                </div>
            </div>

        </div>

        <div class="row no-gutters text-center justify-content-center bot_spa_aft_sect_heading">
            <div class="d-grid">
                <div>
                    <div>
                        <ng-container *ngIf="preQualObj.flow_type==prequalType">
                            {{ 'summarypage.estimatedpurchasetitle' | translate }}
                        </ng-container>
                        <ng-container *ngIf="preQualObj.flow_type==switchType">
                            {{ 'summarypage.estimatedMortgagetitle' | translate }}
                        </ng-container>
                        <ng-container *ngIf="preQualObj.flow_type==prequalType">
                            <button type="button" id="btnttltip" class=" pl-2  btnIconTooltip tip"
                                (click)="$event.stopPropagation();openPopupEn();setPopOver('estimatedPrice')"
                                #ert="ngbPopover" [autoClose]="true" [ngbPopover]="popContent"
                                popoverClass="custom-popover" placement="bottom">
                                <img aria-hidden="true" src="./assets/icons/helpIcon.svg" alt="helpIcon-icon"
                                    role="dialog">
                                <span class="show-for-sr">{{'summarypage.titlePurchasePrice' | translate }}</span>

                            </button>
                        </ng-container>
                        <ng-container *ngIf="preQualObj.flow_type==switchType">
                            <button type="button" id="btnttltip" class=" pl-2  btnIconTooltip tip"
                                (click)="$event.stopPropagation();openPopupEn();setPopOver('estimatedMortgage')"
                                #ert="ngbPopover" [autoClose]="true" [ngbPopover]="popContent"
                                popoverClass="custom-popover" placement="bottom">
                                <img aria-hidden="true" src="./assets/icons/helpIcon.svg" alt="helpIcon-icon"
                                    role="dialog">
                                <span class="show-for-sr">{{'summarypage.titleEstimatedMortgage' | translate }}</span>
                            </button>
                        </ng-container>

                    </div>

                </div>
                <div class="estimated-fontvalue">
                    <ng-container *ngIf="preQualObj.flow_type==prequalType">
                        <ng-container *ngIf="preQualObj?.preQualify_purchase_price>0">
                            {{ preQualObj?.preQualify_purchase_price| currency : 'CAD'
                            : 'symbol-narrow' : '1.0-0' : currentLang }}
                        </ng-container>
                        {{preQualObj?.preQualify_purchase_price?'':'$0.00'}}
                    </ng-container>
                    <ng-container *ngIf="preQualObj.flow_type==switchType">
                        <ng-container *ngIf="preQualObj?.preQualify_mortgage_amount>0">
                            {{ preQualObj?.switchReqAmnt | currency : 'CAD'
                            : 'symbol-narrow' : '1.0-0' : currentLang }}
                        </ng-container>
                        {{preQualObj?.switchReqAmnt?'':'$0.00'}}
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div class="row no-gutters bot_spa_aft_sect_heading">
        <div
            [ngClass]="timerCompleted?' col-12 px-md-5 px-3  py-4 dataCardAterTimer':' col-12 px-md-5 px-3  py-4 dataCard'">
            <ng-container *ngIf="!timerCompleted">
                <div *ngIf="preQualObj.flow_type==prequalType" class="text-center bot_spa_aft_sect_heading summaryEmailTxt">
                    <span>{{'summarypage.downPaymentText' | translate}}</span>
                </div>
                <div *ngIf="preQualObj.flow_type==switchType" class="text-center bot_spa_aft_sect_heading summaryEmailTxt">
                    <span>{{'summarypage.downPaymentSwitch' | translate}}</span>
                </div>
            </ng-container>
            <ng-container *ngIf="timerCompleted">
                <div class="text-center bot_spa_aft_sect_heading">
                    <span>{{'summarypage.paymentTextSwitchTimer' | translate}}</span>
                </div>
            </ng-container>
            <div class="row no-gutters">
                <div class="col-12 bot_spa_aft_sect_heading">
                    <div class="cardcls d-flex align-items-center justify-content-center flex-column py-4 px-3 px-md-0">
                        <ng-container *ngIf="preQualObj.flow_type==prequalType">
                            <div class="d-flex">
                                <span id="downPaymentTitle">{{
                                    'summarypage.downPaymentTitle' | translate }}</span>
                                <button type="button" id="btnttltip" class=" pl-2 infoButton pb-1"
                                    aria-labelledby="emailTextAcc"
                                    (click)="$event.stopPropagation();openPopupEn();setPopOver('downPayment')"
                                    #ert="ngbPopover" [autoClose]="true" [ngbPopover]="popContent"
                                    popoverClass="custom-popover1" placement="bottom">
                                    <img aria-hidden="true" src="./assets/icons/helpIcon.svg" alt="helpIcon-icon"
                                        role="dialog" class="pb-1">
                                    <span class="show-for-sr">{{'summarypage.titleMinMortgageAmount' | translate
                                        }}</span>
                                </button>
                            </div>
                            <span
                                class="bot_spa_aft_sect_heading advisorHeader">{{downPayment
                                |
                                currency :
                                'CAD' : 'symbol-narrow' : '1.0-0': currentLang }} {{downPayment?'':'$0.00'}}
                            </span>
                            <div class="sliderWrapper">
                                <div class="slider-container" [ngStyle]="{'width':sliderWidth,'height':sliderHeight}">
                                    <input type="range" [min]="1" [max]=preQualObj.prequal_slider.length step="1"
                                        [value]=defaultInd (input)="change($event)" class="custom-slider"
                                        [disabled]="timerCompleted" [ngStyle]="{'width':sliderWidth}"
                                        [ngClass]="timerCompleted?'thumb-grey':'thumb-red'"
                                        aria-labelledby="downPaymentTitle"
                                        [attr.aria-valuetext]=" downPayment+' dollars'">
                                    <ng-container
                                        *ngFor="let i of preQualObj.prequal_slider;let last=last;let ind=index;let first=first">
                                        <div class="circle"
                                            [ngStyle]="{'left':leftPosition[ind]+'px','height':sliderCircleHeight,'width':sliderCircleWidth}">
                                            <div *ngIf="indexNumber===ind" [ngClass]="preQualObj.prequal_slider.length > 5? first? 'customToolTip custom-tooltipleft': last? 'customToolTip custom-tooltipright':'customToolTip'
    : 'customToolTip'
">
                                                <div class="infoBox"
                                                    [ngClass]="timerCompleted?'afterTimer':'beforeTimer'">
                                                    <div class="d-grid text-center pt-2">
                                                        <div class="percentage justify-content-center">
                                                            {{downPayment|currency : 'CAD' :
                                                            'symbol-narrow' : '1.0-0' :currentLang}}</div>
                                                    </div>
                                                    <div [ngClass]="preQualObj.prequal_slider.length>5?first?'arrows arrowPosRight':last?'arrows arrowPosleft':'arrows':'arrows'"
                                                        [class]="timerCompleted?'afterTimerArrow':'beforeTimerArrow'">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="preQualObj.flow_type==switchType">

                            <div class="row no-gutters w-100 justify-content-center">
                                <div class="col-md-4 col-12">
                                    <div class="d-flex">
                                        <span class="field_heading_minHeight_label d-flex align-items-center">{{
                                            'summarypage.amortization' | translate
                                            }}</span>
                                        <button type="button" id="btnttltip" class=" pl-2  btnIconTooltip tip"
                                            aria-labelledby="emailTextAcc"
                                            (click)="$event.stopPropagation();openPopupEn();setPopOver('amortization')"
                                            #ert="ngbPopover" [autoClose]="true" [ngbPopover]="popContent"
                                            popoverClass="custom-popover3" placement="bottom">
                                            <img aria-hidden="true" src="./assets/icons/helpIcon.svg"
                                                alt="helpIcon-icon" role="dialog">
                                            <span class="show-for-sr">{{'summarypage.titleAmortization' | translate
                                                }}</span>
                                        </button>

                                    </div>
                                    <ng-container *ngIf="!timerCompleted">
                                        <select class="wdd-fl border-cls" tabindex="0" required id="state" name="state"
                                            [attr.aria-label]="'summarypage.amortization' | translate"
                                            aria-describedby="teststate"
                                            (change)="onAmortizationChange($event.target.value)" aria-required="true">
                                            <option *ngFor="let period of amortizationPeriods" [value]="period"
                                                [selected]="period===selectedAmortization">
                                                {{period}}
                                            </option>
                                        </select>
                                    </ng-container>
                                    <ng-container *ngIf="timerCompleted">
                                        <span class="advisorHeader">{{selectedAmortization}}</span>
                                    </ng-container>
                                </div>
                                <div class="col-md-4 col-12 space_between_field">
                                    <div class="d-flex">
                                        <span class="field_heading_minHeight_label d-flex align-items-center">{{
                                            'summarypage.paymentFrequency' |
                                            translate }}</span>
                                        <button type="button" id="btnttltip1" class=" pl-2 pr-0 btnIconTooltip"
                                            aria-labelledby="emailTextAcc"
                                            (click)="$event.stopPropagation();openPopupFr();setPopOver('paymentFrequency')"
                                            #ert="ngbPopover" [autoClose]="true" [ngbPopover]="popContent"
                                            popoverClass="custom-popover4" placement="bottom">
                                            <img aria-hidden="true" src="./assets/icons/helpIcon.svg"
                                                alt="helpIcon-icon" role="dialog">
                                            <span class="show-for-sr">{{'summarypage.titlePaymentFrequency' | translate
                                                }}</span>
                                        </button>
                                    </div>
                                    <ng-container *ngIf="!timerCompleted">
                                        <select class="wdd-fl border-cls" aria-describedby="payments"
                                            (change)="onpaymentFreqChange($event.target.value)" aria-required="true"
                                            [attr.aria-label]="'summarypage.paymentFrequency' |
                                                                        translate">
                                            <option *ngFor="let frequency of paymentFrequencys" [value]="frequency"
                                                [selected]="frequency===selectedFrequency">{{frequency}}
                                            </option>
                                        </select>
                                    </ng-container>
                                    <ng-container *ngIf="timerCompleted">
                                        <span class=" advisorHeader">{{selectedFrequency}}</span>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="col-12">
                    <ng-container *ngIf="preQualObj.flow_type==prequalType">
                        <div class="row no-gutters">
                            <div
                                class=" col-12 col-md cardcls d-flex flex-column align-items-center justify-content-center py-3">
                                <div class="field_heading_minHeight_label d-flex align-items-center">
                                    <span>
                                        {{'summarypage.estimatedMortgageAmount' |
                                        translate }}
                                    </span>
                                    <button type="button" id="btnttltip1" class=" pl-2 pr-0 btnIconTooltip indexAlign"
                                        aria-labelledby="emailTextAcc"
                                        (click)="$event.stopPropagation();openPopupFr();setPopOver('mortgageAmount')"
                                        #ert="ngbPopover" [autoClose]="true" [ngbPopover]="popContent"
                                        popoverClass="custom-popover2" placement="bottom">
                                        <img aria-hidden="true" src="./assets/icons/helpIcon.svg" alt="helpIcon-icon"
                                            role="dialog">
                                        <span class="show-for-sr">{{'summarypage.titlemorgageAmt' | translate }}</span>
                                    </button>
                                </div>
                                <span class="advisorHeader">
                                    {{ mortgageAmount |
                                    currency : 'CAD' : 'symbol-narrow' : '1.0-0' :currentLang }}
                                    {{mortgageAmount?'':'$0.00'}}
                                </span>
                            </div>
                            <div
                                class="col-12 col-md cardcls d-flex flex-column align-items-center justify-content-center space_between_field py-3">
                                <span
                                    class="field_heading_minHeight_label d-flex align-items-center">{{'summarypage.estimatedMonthlyPayments'
                                    | translate }}</span>
                                <span class="advisorHeader">{{ estimatedPayments | currency : 'CAD' : 'symbol-narrow' : '1.0-0' :currentLang
                                    }}
                                    {{estimatedPayments?'':'$0.00'}}</span>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="preQualObj.flow_type==switchType">
                        <div class="cardcls d-flex align-items-center justify-content-center flex-column py-3">
                            <span class="field_heading_minHeight_label d-flex align-items-center">
                                {{'summarypage.estimatedPayments' | translate }}
                            </span>

                            <span class="advisorHeader">{{ estimatedPaymentsSwitch | currency : 'CAD' : 'symbol-narrow' :
                                '1.0-10' :currentLang }}</span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>


    <ng-container *ngIf="preQualObj.flow_type==prequalType">
        <div class="d-flex justify-content-center bot_spa_aft_sect_heading">
            <span [innerHTML]="'summarypage.preApprovalText'|translate"></span><br>
        </div>
    </ng-container>
    <ng-container *ngIf="preQualObj.flow_type==switchType">
        <div class="d-flex justify-content-center   bot_spa_aft_sect_heading px-3">
            <span *ngIf="rateType!=null&&rateType==fixedRate"
                [innerHTML]="'summarypage.switchRateText'|translate:{productTerm:rateType,productName:productName,switchRateOffer:(clientRate | number:'1.1-2':currentLang),currentDate:formatted}">
            </span>
            <span *ngIf="rateType!=null&&rateType==variableRate"
                [innerHTML]="'summarypage.switchRateTextVariable'|translate:{productTerm:rateType,productName:productName,switchRateOffer: (clientRate | number:'1.1-2':currentLang),switchDiscount: (discount | number:'1.1-2':currentLang),currentDate:formatted}">
            </span>

        </div>
    </ng-container>
    <div class="modal fade" id="exampleModalCenter1" role="dialog" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog modal-dialog-centered float-right" role="document">
            <div class="modal-content model-content-r">
                <button type="button" style="border: 0px;" class="close" data-dismiss="modal" aria-label="Close"
                    tabindex="0">
                    <span class="float-right" aria-hidden="false">&times;</span>
                    <span class="show-for-sr">{{'persInfo.close' | translate }}</span>
                </button>
                <div class="modal-body" *ngIf="preQualObj.cmhc_default_insurance > 0">
                    {{'summarypagepopup.borrowfromCIBCpopup1' |
                    translate:{'mortgage_principal':preQualObj.preQualify_mortgage_amount | currency : 'CAD' :
                    'symbol-narrow' : '1.0-0': currentLang,
                    'insurance_premium':preQualObj.cmhc_default_insurance |
                    currency : 'CAD' : 'symbol-narrow' : '1.0-0': currentLang } }} <br />
                    {{'summarypagepopup.borrowfromCIBCsubpopup1' | translate }}
                </div>
                <div class="modal-body" *ngIf="preQualObj.cmhc_default_insurance == 0">
                    {{'summarypagepopup.borrowfromCIBCpopupnoInterest1' | translate }}
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="exampleModalCenter2" role="dialog" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog modal-dialog-centered float-right" role="document">
            <div class="modal-content model-content-r">
                <button type="button" style="border: 0px;" class="close" data-dismiss="modal" aria-label="Close"
                    tabindex="0">
                    <span class="float-right" aria-hidden="false">&times;</span>
                    <span class="show-for-sr">{{'persInfo.close' | translate }}</span>
                </button>
                <div class="modal-body">
                    <p>{{'summarypagepopup.borrowfromCIBCpopup2' | translate }} </p>
                    <p style="margin-bottom: 0px;">{{'summarypagepopup.borrowfromCIBCsubpopup2' | translate }}
                    </p>
                    <ul>
                        <li>{{'summarypagepopup.borrowfromCIBCpopup3' | translate }}</li>
                        <li>{{'summarypagepopup.borrowfromCIBCpopup4' | translate }}</li>
                        <li>{{'summarypagepopup.borrowfromCIBCpopup5' | translate }}</li>
                        <li>{{'summarypagepopup.borrowfromCIBCpopup6' | translate }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <ng-template #popContent let-type="type">
        <div cdkTrapFocus [cdkTrapFocusAutoCapture]="true" class="tooltip-content" role="dialog">
            <div>

            </div>
            <button type="button" style="border: 0px;" class="close" (click)="closeTolltip();" id="clsTooltipa"
                data-dismiss="modal" aria-label="Close" data-toggle="tooltip" data-placement="bottom">

                <span class="float-right danger" aria-hidden="true">&times;</span>

                <span class="show-for-sr">{{'persInfo.close' | translate}}</span>
            </button>
            <div class="modal-body">
                <ng-container *ngIf="popOverType==='downPayment'">
                    {{'summarypagepopup.downPaymentPopUp' | translate }}
                </ng-container>
                <ng-container *ngIf="popOverType==='amortization'">
                    {{'summarypagepopup.amortizationPopUp' | translate }}
                </ng-container>
                <ng-container *ngIf="popOverType==='mortgageAmount'">
                    <p class="m-0">{{'summarypagepopup.borrowfromCIBCpopup1' |
                        translate:{mortgage_principal:mortgage_principal|currency : 'CAD' : 'symbol-narrow' :
                        '1.0-0'
                        :currentLang,insurance_premium:insureFee|currency : 'CAD' : 'symbol-narrow' : '1.0-0'
                        :currentLang} }}</p>
                    <p>{{'summarypagepopup.borrowfromCIBCsubpopup1' | translate}}</p>
                </ng-container>
                <ng-container *ngIf="popOverType==='paymentFrequency'">
                    {{'summarypagepopup.paymentFrequencyPopUp' | translate }}
                </ng-container>
                <ng-container *ngIf="popOverType==='estimatedPrice'">
                    <p class="m-0">{{'summarypagepopup.popup1Content' | translate:{downPayment:
                        downPayment|currency : 'CAD' : 'symbol-narrow' : '1.0-0'
                        :currentLang,mortgageAmount:mortgageAmount|currency : 'CAD' : 'symbol-narrow' : '1.0-0'
                        :currentLang,insureFee:insureFee|currency : 'CAD' : 'symbol-narrow' : '1.0-0'
                        :currentLang,prequalRate:rate} }}</p>
                    <p>{{'summarypagepopup.popup1ContentNext' | translate}}</p>
                </ng-container>
                <ng-container *ngIf="popOverType==='estimatedMortgage'">
                    <p class="m-0"><b>{{'Online Banking
                            account.tipTitleNoteSwitch'|translate}}</b>{{'summarypagepopup.popup1ContentSwitch1'
                        |
                        translate }}<br>{{'summarypagepopup.popup1ContentSwitch2' |
                        translate:{Amortization:selectedAmortizationPopUp} }}</p>
                </ng-container>
            </div>
        </div>
    </ng-template>
    <ng-template #popContent1 let-modal>
        <div class="modal-content" role="dialog">
            <div class="d-flex justify-content-between p-3">
                <div></div>
                <button type="button" style="border: 0px;" class="close" (click)="modal.dismiss();" id="clsTooltipa"
                    aria-label="Close" data-toggle="tooltip">

                    <span class="float-right danger" aria-hidden="true">&times;</span>
                    <span class="show-for-sr">{{'persInfo.close' | translate}}</span>
                </button>
            </div>
            <div class="modal-body">
                <div style="text-align: center;">{{'summarypagepopup.closeMsg' | translate }}</div>
                <div class="d-flex flex-row-reverse">
                    <button aria-label="close" type="button" class=" desktop-view-btn buttonCommon saveNextBtn m-3 "
                        (click)="closeWindow()">{{
                        'summarypagepopup.closebutton' | translate }}</button>
                </div>
            </div>
        </div>
    </ng-template>


    <div class="row no-gutters  bot_spa_aft_sect_heading">
        <div class="col-12 advisorContainer">
            <div class="row no-gutters bot_spa_aft_sect_heading">
                <div class="col-12 text-center">
                    <span class="advisorHeader">
                        {{'summarypage.mortgageadvisortitle' | translate }}
                    </span>
                </div>
            </div>
            <div class="row no-gutters justify-content-around">
                <div class="col-md-3 col-12 d-flex flex-column align-items-center align-items-md-start">
                    <span class="advisorHeader bot_spa_sec2_heading">{{preQualObj?.madvsior?.firstname}} {{preQualObj?.madvsior?.lastname}}
                    </span>
                    <div>
                        <div class="bot_spa_sec2_heading">
                            <img aria-hidden="true" src="./assets/icons/Mobile.svg" alt="helpIcon-icon" role="dialog">
                            <a [href]="'tel:'+advisorNumber" tabindex="0">
                                <span class="contactNumber advisorFontStyle">
                                    <ng-container *ngIf="msaUser">
                                        {{advisorNumber | mask: '0-000-000-0000 - 0000'}}
                                    </ng-container>
                                    <ng-container *ngIf="!msaUser">
                                        {{advisorNumber | mask: '000-000-0000'}}
                                    </ng-container> </span>
                                <span class="show-for-sr">{{'header.txtPhn' |translate}}</span>
                            </a>
                        </div>
                        <div>
                            <a [href]="'mailto:'+ preQualObj?.madvsior?.email" class="d-flex">
                                <span> <img aria-hidden="true" src="./assets/icons/Mail.svg" alt="helpIcon-icon"
                                        role="dialog"></span>
                                <u tabindex="0" class="contactNumber advisorFontStyle">
                                    {{preQualObj?.madvsior?.email}}
                                    <span class="show-for-sr">{{'summarypage.tootipEmail' |translate}}</span>
                                </u>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12 top_spa_aft_mobile_sect_heading">
                    <ng-container *ngIf="preQualObj.flow_type==prequalType">
                        {{'summarypage.provideyouwithpersonalizedtitle' | translate }}
                    </ng-container>
                    <ng-container *ngIf="preQualObj.flow_type==switchType">
                        {{'summarypage.provideyouwithpersonalizedtitleSwitch' | translate }}
                    </ng-container>
                    <ng-container *ngIf="!isReferralMaPresent&&referral">
                        {{'summarypage.inactiveMA'|translate}}
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="row no-gutters">
        <div class="col-12 text-center advisorFontStyle">
            <span>
                {{'summarypage.reference'|translate}}
            </span>
            <span>{{preQualObj?.preQualify_mortgage_reference_number?preQualObj?.preQualify_mortgage_reference_number:'NA'
                }}</span>
        </div>
    </div>
</div>